import React from 'react';
import { getPlayerUrlById, getTeamUrl } from '../../../utils/routes';
import {
  /* translateCountry, */ translatePosition,
} from '../../../utils/translate';
import { getProxyUrl } from '../../../utils/image';

function PlayersTableRow({ player, i, orderBy }) {
  // const countrySv = translateCountry(player?.nationality);
  const positionSv = translatePosition(player?.position);
  const playerUrl = getPlayerUrlById(player?.fogisId);
  const teamUrl = player?.teamAbbrv ? getTeamUrl(player?.teamAbbrv) : '';
  const teamLogo = getProxyUrl(
    player?.teamLogo && player?.teamDisplayName
      ? player?.teamLogo
      : '/wp-content/themes/sef-leagues/images/generic-team.png',
    22,
    22
  );
  return (
    <>
      {i === 1 ? (
        <div
          className="player-bust d-md-none pb-0"
          style={{ margin: '0 auto', width: '180px' }}
        >
          <div className="player-bust__images">
            <img
              className="player-bust__player-image"
              src={player?.playerImage}
              alt={player?.displayName}
            />
            <img
              alt={player?.teamDisplayName}
              className="player-bust__team-image"
              src={player?.teamLogo}
            />
          </div>
        </div>
      ) : (
        ''
      )}
      <div
        className={`stats-table__row ${
          player?.ranking === 1 ? 'bg-comp-pink' : ''
        }`}
      >
        <div className="col-1 col-md-1 text-center stats-font-larger stats-font-adjust">
          {player?.ranking}
        </div>
        <a
          style={{ pointerEvents: playerUrl ? 'auto' : 'none' }}
          href={playerUrl || ''}
          className="col-9 col-md-3 name-with-team-logo name-with-team-logo--desktop-hide-logo"
        >
          <div
            className={
              teamLogo
                ? `name-with-team-logo name-with-team-logo--desktop-hide-logo`
                : ''
            }
          >
            <img src={teamLogo} alt={player?.teamDisplayName} />
            <span className="d-none d-sm-inline-block text-color-primary-white stats-font-larger stats-font-adjust">
              {player?.displayName}
            </span>
            <span className="d-inline-block d-sm-none text-color-primary-white stats-font-larger stats-font-adjust">
              {player?.displayName}
            </span>
          </div>
        </a>
        <a
          style={{ pointerEvents: teamUrl ? 'auto' : 'none' }}
          href={teamUrl}
          className="col-auto col-md-2 d-none d-md-flex name-with-team-logo name-with-team-logo--mobile-hide-logo"
        >
          <div className="name-with-team-logo name-with-team-logo--mobile-hide-logo">
            <img src={teamLogo} alt={player?.teamDisplayName} />
            <span className="d-none d-sm-inline-block text-color-primary-white stats-font-adjust">
              {player?.teamDisplayName}
            </span>
            <span className="d-inline-block d-sm-none text-color-primary-white stats-font-adjust">
              {player?.teamDisplayName}
            </span>
          </div>
        </a>
        <div className="col-auto col-md-2 d-none d-md-block stats-font-adjust">
          {positionSv}
        </div>
        {/*
        <div className="col-auto col-md-2 d-none d-md-block stats-font-adjust">
          {countrySv}
        </div>
        */}
        <div className="col-auto col-md-2 text-center d-none d-md-block stats-font-adjust">
          {player?.matchesPlayed}
        </div>
        <div className="col-auto col-md-1 text-center stats-font-larger stats-font-adjust">
          {player[orderBy]}
        </div>
      </div>
    </>
  );
}
export default PlayersTableRow;
